import { render } from "./BrandModal.vue?vue&type=template&id=3332e99e"
import script from "./BrandModal.vue?vue&type=script&lang=ts"
export * from "./BrandModal.vue?vue&type=script&lang=ts"
script.render = render

export default script